import { render, staticRenderFns } from "./ProjectChangesHistory.vue?vue&type=template&id=dc87fb0e&scoped=true&"
import script from "./ProjectChangesHistory.vue?vue&type=script&lang=js&"
export * from "./ProjectChangesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc87fb0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable})
